import { useEffect, useState } from 'react';
import { number } from 'prop-types';
import classNames from 'classnames';

import css from './CountUpNumber.less';

const convertTimeDisplay = second => {
  if (second <= 0) return '<1';
  const minute = Math.ceil(second / 60);
  return `${minute}+`;
};

const duration = 500;

function CountUpNumber({ value }) {
  const [countUp, setCountUp] = useState(false);

  useEffect(() => {
    if (value % 60 === 1) {
      setCountUp(true);
      setTimeout(() => {
        setCountUp(false);
      }, duration);
    }
  }, [value]);

  return (
    <div className={css.wrapCounter}>
      <div className={classNames(css.wrapCounterContent, { [css.countUp]: countUp })}>
        <div className={css.tempValue}>{convertTimeDisplay(value - 1)}</div>
        <div className={css.newValue}>{convertTimeDisplay(value)}</div>
      </div>
    </div>
  );
}

CountUpNumber.defaultProps = {
  value: 0,
};

CountUpNumber.propTypes = {
  value: number,
};

export default CountUpNumber;
